import {CAT_ANALYTICS, CAT_FUNCTIONALITY, CAT_NECESSARY} from "../ConsentCookieDefinitions";

// Seccion Encabezado de la Modal de configuración de Preferencias
const SECTION_PRIMARY_DEF = {
  description: `<span>You can configure and/or accept the use of cookies through the checkboxes shown below.</span>
<span>If you want more information, you can visit our <a href="/politica-de-cookies-ue" target="_blank"><strong>Extended Cookies Policy</strong></a></span>
`
};

// Seccion Cookies Necesarias de la Modal de Preferencias
const SECTION_NECESSARY_DEF = {
  title: 'Strictly Necessary (Technical)',
  description:'Strictly necessary cookies ensure functions that are essential for the proper functioning of the website. As a result, these cookies cannot be disabled. They are exclusively used on this website and, therefore, are first-party cookies. This means that all information stored in the cookies will only be sent to this website.',
  linkedCategory: CAT_NECESSARY
}

// Seccion Funcionales o personalizadas de la Modal de Preferencias
const SECTION_FUNCTIONALITY_DEF = {
  title: 'Preferences',
  description:'Preference cookies allow the website to remember information that changes the way the website behaves or looks, such as your preferred language or the region you are in.',
  linkedCategory: CAT_FUNCTIONALITY
};

// Seccion Analitica GOOGLE Tagmanager de la Modal de Preferencias
const SECTION_ANALYTICS_DEF = {
  title: 'Analytics',
  description:
      'Statistical cookies help website owners understand how visitors interact with the website by collecting and providing information anonymously',
  linkedCategory: CAT_ANALYTICS,
};

export const CONFIGURATION_EN = {
  consentModal: {
    description:
        `Indra Sistemas S.A. uses its own and third-party cookies to record user browsing activities, quantify the number of users, and perform statistical measurement and analysis of the use that users make of the offered service. You can configure and/or accept the use of cookies through the checkboxes shown below. If you want more information, you can visit our <a href='/politica-de-cookies-ue'>Extended Cookies Policy</a>`,
    acceptAllBtn: 'Accept all',
    acceptNecessaryBtn: 'Accept necessary only',
    showPreferencesBtn: 'Manage preferences',
  },
  preferencesModal: {
    title: 'Manage cookie preferences',
    acceptAllBtn: 'Accept all',
    acceptNecessaryBtn: 'Reject All',
    savePreferencesBtn: 'Accept current selection',
    closeIconLabel: 'Close modal',
    sections: [
      SECTION_PRIMARY_DEF,
      SECTION_NECESSARY_DEF,
      //SECTION_FUNCTIONALITY_DEF,
      SECTION_ANALYTICS_DEF,
    ],
  },
}
